import AdicionalGrupoItemService from "@/services/AdicionalGrupoItemService";

export const adicionalGrupoItem = {
  namespaced: true,
  state: {
    adicionalGrupoItem: {},
  },
  actions: {
    getAdicionalGrupoItem({ commit }, payload) {
      return AdicionalGrupoItemService.GetAdicionalGrupoItem(payload).then(
        (adicionalGrupoItem) => {
          return Promise.resolve(adicionalGrupoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAdicionalGrupoItem({ commit }, payload) {
      return AdicionalGrupoItemService.PostAdicionalGrupoItem(payload).then(
        (adicionalGrupoItem) => {
          return Promise.resolve(adicionalGrupoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAdicionalGrupoItem({ commit }, payload) {
      return AdicionalGrupoItemService.PutAdicionalGrupoItem(payload).then(
        (adicionalGrupoItem) => {
          return Promise.resolve(adicionalGrupoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAdicionalGrupoItem({ commit }, payload) {
      return AdicionalGrupoItemService.DeleteAdicionalGrupoItem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAdicionalGrupoItemOData({ commit }, payload) {
      return AdicionalGrupoItemService.GetAdicionalGrupoItemOData(payload).then(
        (adicionalGrupoItem) => {
          return Promise.resolve(adicionalGrupoItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default adicionalGrupoItem;
